import { Injectable } from '@angular/core';
import { AppConfig } from './app-config';
import { HttpClient } from '@angular/common/http';
 

@Injectable({ providedIn: 'root' })
export class AppConfigService extends AppConfig {
    constructor( private http: HttpClient) {
        super();
  }
  load() {
    return this.http.get<AppConfig>('app.config.json')
      .toPromise()
      .then(data => {      
        this.urlKeysApi = data.urlKeysApi;       
      })
      .catch(() => {
        console.error('No se pudo cargar la configuracion. Verifique archivo app.config.json');
      });
  }
}
